module.exports = __webpack_public_path__ + "img/jo.2198eac0.svg";